import {SpavaObj} from './SpavaObj'
import {Vehicle, PassRule, PassGroup} from './PassControl'
import {Person} from './UserAdmin'

class Appl {
  applId

  constructor (o) {
    if (o instanceof Appl) return o
    o = o || {}
    this.applId = o.applId || ''
  }
}

class Host {
  hostGroupId
  hostId
  hostOrgId

  constructor (o) {
    if (o instanceof Host) return o
    o = o || {}
    this.hostGroupId = o.hostGroupId || ''
    this.hostId = o.hostId || ''
    this.hostOrgId = o.hostOrgId || ''
  }
}

class VeSelfRegRule {
  id
  idType
  name
  org
  phone
  veNum

  constructor (o) {
    if (o instanceof VeSelfRegRule) return o
    o = o || {}
    this.id = o.id || false
    this.idType = o.idType || false
    this.name = o.name || false
    this.org = o.org || false
    this.phone = o.phone || true
    this.veNum = o.veNum || true
  }
}

class LetterReservation {
  appl
  bulkImpVeList
  host
  letterApptDesc
  letterApptName
  letterApptType
  maxSelfReg
  needReview
  passRuleConf
  passRulePara
  passRuleType
  qrcodeEndDtm
  qrcodeStaDtm
  veSelfRegRule

  constructor (o) {
    if (o instanceof LetterReservation) return o
    o = o || {}
    this.appl = o.appl instanceof Appl ? o.appl : new Appl()
    this.bulkImpVeList = o.bulkImpVeList instanceof Array ? o.bulkImpVeList : []
    this.host = o.host instanceof Host ? o.host : new Host()
    this.letterApptDesc = o.letterApptDesc || ''
    this.letterApptName = o.letterApptName || ''
    this.letterApptType = o.letterApptType || ''
    this.maxSelfReg = o.maxSelfReg || ''
    this.needReview = o.needReview || false
    this.passRuleConf = o.passRuleConf instanceof Array ? o.passRuleConf : []
    this.passRulePara = o.passRulePara instanceof Array ? o.passRulePara : []
    this.qrcodeEndDtm = o.qrcodeEndDtm || ''
    this.qrcodeStaDtm = o.qrcodeStaDtm || ''
    this.veSelfRegRule = o.veSelfRegRule instanceof VeSelfRegRule ? o.veSelfRegRule : new VeSelfRegRule()
    this.passRuleType = o.passRuleType instanceof String ? o.passRuleType : ''
  }
}

class Reservation extends SpavaObj {
  static ADMIN = 'admin'
  static ORG = 'org'
  static ORGANIZATION = Reservation.ORG
  static PERSONAL = 'person'
  static LETTER_WORK = 'letter_work'
  static LETTER_BUSINESS = 'letter_business'
  static LETTER_APPEND = 'letter_append'
  static LETTER_APPEND_SELF = 'letter_append_self'
  static STATUS = {
    PENDING: '1',
    ACTIVE: '0',
    EXPIRE: '-1'
  }
  name
  groupId
  description
  type
  rules // 针对车的特殊规则
  vehicle
  applicant
  owner // 联系人
  startDatetime
  endDatetime
  phone
  status
  ownerId

  constructor (o) {
    if (o instanceof Reservation) return o
    super(o)
    o = o || {}
    this.vehicle = o.vehicle instanceof Vehicle ? o.vehicle : o.vehicle ? new Vehicle(o.vehicle) : null
    this.applicant = SpavaObj.getObjKey(o.applicant, Person)
    this.owner = SpavaObj.getObjKey(o.owner, Person)
    this.rules = o.rules instanceof Array ? o.rules.map(r => r instanceof PassRule ? r : new PassRule(r)) : []
    this.name = o.visitor.name || ''
    this.phone = o.visitor.phone
    this.description = o.description || ''
    this.type = o.type || null
    this.groupId = o.groupId || ''
    this.startDatetime = o.startDatetime || ''
    this.endDatetime = o.endDatetime || ''
    this.ownerId = o.ownerId || ''
    if (!isNaN(o.status)) {
      this.status = String(o.status)
    }
    else if (Date.now() < this.startDatetime) {
      this.status = Reservation.STATUS.PENDING
    }
    else if (Date.now() >= this.startDatetime && Date.now() <= this.endDatetime) {
      this.status = Reservation.STATUS.ACTIVE
    }
    else {
      this.status = Reservation.STATUS.EXPIRE
    }
  }

  get plate () {
    return this.vehicle && this.vehicle.plate
  }

  get ownerName () {
    return this.owner && this.owner.name
  }

  get applicantName () {
    return this.applicant && this.applicant.name
  }

  get visitorName () {
    return this.visitor && this.visitor.name
  }

  get visitor () {
    return this.vehicle && this.vehicle.owner
  }

  get isExpire () {
    return this.status === Reservation.STATUS.EXPIRE
  }

  get isActive () {
    return this.status === Reservation.STATUS.ACTIVE
  }

  get isPending () {
    return this.status === Reservation.STATUS.PENDING
  }

  static fromAPI (o) {
    o.vehicle = {
      plate: o.visitorObjectCode,
      owner: o.visitor
    }
    o.startDatetime = o.sdtime
    o.endDatetime = o.edtime
    let map = {
      order_object: Reservation.PERSONAL,
      order_group: Reservation.ORG,
      admin: Reservation.ADMIN,
      letter_business: Reservation.LETTER_BUSINESS,
      letter_work: Reservation.LETTER_WORK,
      letter_append: Reservation.LETTER_APPEND,
      letter_append_self: Reservation.LETTER_APPEND_SELF
    }
    o.type = map[o.orderType]
    o.groupId = o.obgrpId
    try {
      let j = JSON.parse(o.rhdata) || {}
      o.status = j.r_h_status
    }
    catch (e) {
    }
    return new Reservation(o)
  }
}

class ReservationGroup extends PassGroup {
  applicant
  owner

  constructor (o) {
    super(o)
    o = o instanceof Object ? o : {}
    this.applicant = SpavaObj.getObjKey(o.applicant, Person)
    this.owner = SpavaObj.getObjKey(o.owner, Person)
  }

  static fromAPI (o) {
    let g = super.fromAPI(o)
    // console.log(g, new ReservationGroup({...g}))
    return new ReservationGroup({...g})
  }
}

class ReservationAuthority {
  constructor (
    {
      name,
      minStartDay = 0,
      maxStartDay = 5,
      maxDurationDay = 5,
      maxRuleAmount = 1,
      maxVehicleAmount = 99999,
      minSliceTime,
      maxSliceTime,
      type = ['sectional'], // sectional, day, week
      editGroupInfo = false,
      editPrompt = false,
      presetCtrls = [],
      limitAreaConfigs = [] 
    }) {
    if (!name) {
      throw Error('预约名称不能为空')
    }
    return {
      name: name,
      minStartDay: minStartDay,
      maxStartDay: maxStartDay,
      minSliceTime: minSliceTime,
      maxSliceTime: maxSliceTime,
      maxDurationDay: maxDurationDay,
      maxRuleAmount: maxRuleAmount,
      maxVehicleAmount: maxVehicleAmount,
      editGroupInfo: editGroupInfo,
      type: type,
      editPrompt: editPrompt,
      presetCtrls: presetCtrls,
      limitAreaConfigs: limitAreaConfigs
    }
  }
}

class Visitor extends Person {
  orgName
  typeName = '访客'

  constructor (o) {
    super(o)
    o = o instanceof Object ? o : {}
    this.orgName = o.orgName
  }

  static fromAPI (o) {
    o = o || {}
    o.phone = o.visitorPhone || ''
    o.orgName = o.visitorOrg || ''
    o.idNumber = o.visitorIdNum || ''
    o.idType = o.visitorIdType || ''
    o.name = o.visitorName
    return new Visitor(o)
  }
}

export {
  ReservationGroup,
  Reservation,
  LetterReservation,
  Appl,
  Host,
  VeSelfRegRule,
  ReservationAuthority,
  Visitor
}
